import { defineMessage } from 'services/localization';

export const messages = {
    settingsName: defineMessage('workflows_and_settings'),
    workflowsName: defineMessage('approval_workflows'),
    usersName: defineMessage('users'),
    customFieldsName: defineMessage('fields'),
    organisationSettingsName: defineMessage('organisation_settings_and_connection'),
    organisationSettingsStandaloneName: defineMessage('organisation_settings'),
    bankAccounts: defineMessage('bank_accounts'),
    contactPaymentDetails: defineMessage('contact_details_1'),
};
